import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./OrientationGuard.module.css";

const OrientationGuard = () => {
    const location = useLocation();
    const [isMobileDevice, setIsMobileDevice] = useState(false);
    const [isLandscape, setIsLandscape] = useState(false);

    useEffect(() => {
        const checkDeviceAndOrientation = () => {
            // Check if device is a mobile/touch device (not a desktop or laptop with mouse)
            const isTouch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
            const isSmall = window.innerWidth <= 1024;
            const isLand = window.innerWidth > window.innerHeight;

            setIsMobileDevice(isTouch && isSmall);
            setIsLandscape(isLand);
        };

        checkDeviceAndOrientation();
        window.addEventListener("resize", checkDeviceAndOrientation);
        window.addEventListener("orientationchange", checkDeviceAndOrientation);

        return () => {
            window.removeEventListener("resize", checkDeviceAndOrientation);
            window.removeEventListener("orientationchange", checkDeviceAndOrientation);
        };
    }, []);

    // 1. NEVER show on desktop / laptop / Windows
    if (!isMobileDevice) {
        return null;
    }

    // 2. ONLY show when user tries to open persona profile or edit persona details
    const path = location.pathname.toLowerCase();
    const isPersonaAction = 
        path.includes("persona") || 
        path.includes("template") ||
        path.includes("chosetemplate") ||
        path.includes("get-started/personal") ||
        path.includes("get-started/professional");

    if (!isPersonaAction) {
        return null;
    }

    // 3. ONLY show when device is held in landscape mode (instructing to rotate to portrait)
    if (!isLandscape) {
        return null;
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.content}>
                <div className={styles.iconWrapper}>
                    <svg 
                        width="80" 
                        height="80" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="white" 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        className={styles.rotateIcon}
                    >
                        <path d="M1 4v6h6" />
                        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
                        <rect x="7" y="12" width="10" height="16" rx="2" transform="rotate(-90 12 15)" stroke="white" />
                    </svg>
                </div>
                <h1>Please Rotate Your Device</h1>
                <p>This website is best viewed in portrait mode.</p>
            </div>
        </div>
    );
};

export default OrientationGuard;


